import { differenceInMinutes } from "date-fns";
import { useEffect } from "react";

import { SETTINGS_SECTION_KEYS, SettingsSection } from "constants/settings/sections";
import { useAgentFlag } from "hooks/use-agent-flag";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useSettingsSection(section: SettingsSection) {
  const [lastVisitedDate, setVisitedDate] = useAgentFlag(SETTINGS_SECTION_KEYS[section]);

  const shouldUpdate = !lastVisitedDate || Math.abs(differenceInMinutes(new Date(), lastVisitedDate)) > 2;

  useEffect(() => {
    if (shouldUpdate) {
      setVisitedDate(new Date().toISOString());
    }
  }, [setVisitedDate, shouldUpdate]);
}
